import React from 'react';
import {
  Box,
  Typography,
  Link,
} from '@mui/material';
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material';

const PriorityMatrix: React.FC = () => {
  const links = [
    { title: 'OC 3, G 3', url: 'https://www.notion.so/Bag-OC-3-G-3-NOT_WORK_HOURS-22f296896e1380718b6de7503d626d82?pvs=21' },
    { title: 'OC ?, G ?', url: 'https://www.notion.so/Bag-OC-G-NOT_WORK_HOURS-22f296896e138070af6afc84dba8241d?pvs=21' },
    { title: 'OC 3, G 2', url: 'https://www.notion.so/Bag-OC-3-G-2-NOT_WORK_HOURS-22f296896e1380c19f04e71f906b1ca3?pvs=21' },
    { title: 'OC 2, G 3', url: 'https://www.notion.so/OC-2-G-3-NOT_WORK_HOURS-231296896e138035bb22eb3e659d178e?pvs=21' },
    { title: 'OC 2, G 2', url: 'https://www.notion.so/Bag-OC-2-G-2-NOT_WORK_HOURS-AT_MY_COMP-22f296896e1380c8bd27e1426025238e?pvs=21' },
    { title: 'OC 2, G 1', url: 'https://www.notion.so/Bag-OC-2-G-1-NOT_WORK_HOURS-22f296896e13809795f2c0fb4e22d690?pvs=21' },
    { title: 'OC 1, G 3', url: 'https://www.notion.so/Bag-OC-1-G-3-NOT_WORK_HOURS-WITH_PHONE-22f296896e1380198a2ff15be0e164f4?pvs=21' },
    { title: 'OC 1, G 2', url: 'https://www.notion.so/Bag-OC-1-G-2-NOT_WORK_HOURS-AT_MY_COMP-22f296896e1380e39dc6fea6d3a9c460?pvs=21' },
    { title: 'OC 1, G 1', url: 'https://www.notion.so/Bag-OC-1-G-1-NOT_WORK_HOURS-22f296896e13806e9887e56baa33baf5?pvs=21' },
  ];

  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6" gutterBottom>
        Priority Matrix
      </Typography>
      
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        {links.map((link) => (
          <Link
            key={link.title}
            href={link.url}
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              fontSize: '1rem',
              fontWeight: 500,
              color: 'primary.main',
              '&:hover': {
                color: 'primary.light',
              },
            }}
          >
            {link.title}
            <OpenInNewIcon fontSize="small" />
          </Link>
        ))}
      </Box>
    </Box>
  );
};

export default PriorityMatrix;
